import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const comparisons = [
  {
    title: 'vs. Hiring Additional Staff ($3,500–5,000/mo per person)',
    cons: [
      'Works 8 hours/day, 5 days/week only',
      '2–3 weeks of training before productive',
      'Sick days, turnover, benefits overhead',
    ],
    pros: [
      'Valtivo: 24/7/365, handles calls in <2 seconds, no training needed',
    ],
  },
  {
    title: 'vs. Basic IVR / Phone Trees',
    cons: [
      '"Press 1 for sales" — customers hate it',
      'No intelligence, no resolution, just routing',
      '67% of callers hang up on IVR systems',
    ],
    pros: [
      'Valtivo: Natural conversation, captures structured details, notifies your team instantly',
    ],
  },
  {
    title: 'vs. Building It Yourself',
    cons: [
      'Weeks of technical integration work',
      'Requires API knowledge (Twilio, LLM orchestration)',
      'Ongoing maintenance and prompt engineering',
    ],
    pros: [
      'Valtivo: Done-for-you in 48–72 hours, we handle all optimization',
      'Valtivo: Dedicated AI number with conditional forwarding — plugs into your existing phone system with zero changes on your end',
    ],
  },
  {
    title: 'vs. Outsourced Call Centers',
    cons: [
      '$8–15 per call, minimum monthly commitments',
      'Script-reading agents with no product knowledge',
      'Inconsistent quality and difficult to monitor',
    ],
    pros: [
      'Valtivo: Flat monthly rate, consistent quality, trained on YOUR knowledge base',
      'Valtivo: Your team answers first — AI catches what they miss and sends a structured summary so nothing falls through the cracks',
    ],
  },
];

const Comparison = () => (
  <section className="py-12 md:py-16 bg-white border-b border-slate-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10 md:mb-12">
        <h2 className="text-3xl font-bold text-slate-900 mb-4">Why Choose Valtivo Over...</h2>
      </div>
      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        {comparisons.map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="bg-slate-50 rounded-2xl p-6 border border-slate-200"
          >
            <h3 className="text-lg font-bold text-slate-900 mb-4">{item.title}</h3>
            <div className="space-y-3 mb-6">
              {item.cons.map((con, j) => (
                <div key={j} className="flex items-start gap-3 text-sm text-slate-600">
                  <SafeIcon icon={FiX} className="w-5 h-5 text-red-500 flex-shrink-0" />
                  <span>{con}</span>
                </div>
              ))}
            </div>
            <div className="pt-4 border-t border-slate-200 space-y-3">
              {item.pros.map((pro, j) => (
                <div key={j} className="flex items-start gap-3 text-sm font-semibold text-slate-900">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span>{pro}</span>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Comparison;